// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ddhjC","toggleWrap":"styles_toggleWrap__uyE7A","content":"styles_content__3ZHvF","selectAreaCode":"styles_selectAreaCode__2PDfa"};